import { Injectable } from '@angular/core';
import {
  GlobalVariablesService,
  GoogleAnalyticResponse
} from '@tmhcc-ng-lib/data-service';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { GoogleAnalyticService } from 'libs/data-service/google-analytic.service';
import { Scripts } from '../def/script';
// import {ScriptStore} from "./script.store";

declare var document: any;

@Injectable()
export class ScriptLoaderService {
  private scripts: any = [];

  constructor(
    private googleAnalyticService: GoogleAnalyticService,
    private globalVariables: GlobalVariablesService,
    protected configService: AppConfigService
  ) {}

  load(scripts: Scripts[]) {
    this.globalVariables.gaTrackingId = ''; //this.configService.config.googleAnalyticsTrackingId;

    scripts.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };

      var promises: any[] = [];
      scripts.forEach(script => promises.push(this.loadScript(script.name)));
      return Promise.all(promises);
    });
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      //resolve if already loaded
      if (this.scripts[name].loaded) {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      } else {
        //load script
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {
          //IE
          script.onreadystatechange = () => {
            if (
              script.readyState === 'loaded' ||
              script.readyState === 'complete'
            ) {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({ script: name, loaded: true, status: 'Loaded' });
            }
          };
        } else {
          //Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          };
        }
        script.onerror = (error: any) =>
          resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }

  unload(filename, filetype) {
    var targetelement =
      filetype == 'js' ? 'script' : filetype == 'css' ? 'link' : 'none'; //determine element type to create nodelist from
    var targetattr =
      filetype == 'js' ? 'src' : filetype == 'css' ? 'href' : 'none'; //determine corresponding attribute to test for
    var allsuspects = document.getElementsByTagName(targetelement);
    for (var i = allsuspects.length; i >= 0; i--) {
      //search backwards within nodelist for matching elements to remove
      if (
        allsuspects[i] &&
        allsuspects[i].getAttribute(targetattr) != null &&
        allsuspects[i].getAttribute(targetattr).indexOf(filename) != -1
      )
        allsuspects[i].parentNode.removeChild(allsuspects[i]); //remove element by calling parentNode.removeChild()
    }
  }
}
